import { Component, ContentChildren, QueryList } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';
import { ListComponent } from '../list.component';

@Component({
    selector: 'lib-list-group',
    templateUrl: './list-group.component.html',
    styleUrls: ['./list-group.component.scss']
})
export class ListGroupComponent<T> extends BaseViewComponent {
    @ContentChildren(ListComponent) lists!: QueryList<ListComponent<T>>;

    ExpandAll(value: boolean): void {
        this.lists.forEach(list => {
            list.SetPanelOpen(value);
        });
    }

    SelectAll(value: boolean): void {
        this.lists.forEach(list => {
            list.ToggleSelectAll(value);
        });
    }
}
